import axios from "../plugins/parseAxios";
export class ApproveTaskAPI {
  static getApproveTasksByMarket(payload) {
    return axios.post(`functions/getApproveTasksByMarket`, payload);
  }
  static getApproveTaskSettingByMarket(payload) {
    return axios.post(`functions/getApproveTaskSettingByMarket`, payload);
  }
  static approveApproveTask(payload) {
    return axios.post(`functions/approveApproveTask`, payload);
  }
  static rejectApproveTask(payload) {
    return axios.post(`functions/rejectApproveTask`, payload);
  }
}
